
<template>
    <div>
        <el-card class="box-card">
            <template #header>
                <div class="card-header">
                    <span>门店设备列表</span>
                    <el-button type="primary" @click="handleAddDevice">新增设备</el-button>
                </div>
            </template>

            <el-table :data="deviceList" border style="width: 100%">
                <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
                <el-table-column prop="equipmentId" label="设备编号" align="center"></el-table-column>
                <el-table-column prop="storeName" label="门店名称" align="center"></el-table-column>
                <el-table-column prop="createTime" label="绑定时间" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="150">
                    <template #default="scope">
                        <el-button type="danger" size="mini" @click="handleDeleteDevice(scope.row)">解绑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 新增设备对话框 -->
        <el-dialog v-model="dialogVisible" title="新增设备" width="500px">
            <el-form :model="form" ref="formRef" label-width="100px">
                <el-form-item label="设备编号" prop="equipmentId" :rules="[{ required: true, message: '请输入设备编号', trigger: 'blur' }]">
                    <el-input v-model="form.equipmentId" placeholder="请输入设备编号"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>import { reactive, ref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {
    apiStoreEqConfigList,
    apiStoreEqConfigSave,
    apiStoreEqConfigDelete
} from "@/api/requestApis";

export default {
    name: "StoreEquipmentList",
    props: {
        storeId: {
            type: [String, Number],
            required: true
        }
    },
    setup(props) {
        const deviceList = ref([]);
        const dialogVisible = ref(false);
        const formRef = ref(null);

        const form = reactive({
            equipmentId: "",
            storeId: ""
        });

        // 获取设备列表
        const getDeviceList = async () => {
            try {
                const params = {
                    storeId: props.storeId
                };
                const res = await apiStoreEqConfigList(params);
                deviceList.value = res.records || [];
            } catch (error) {
                ElMessage.error("获取设备列表失败: " + error);
            }
        };

        // 新增设备
        const handleAddDevice = () => {
            form.equipmentId = "";
            form.storeId = props.storeId;
            dialogVisible.value = true;
        };

        // 提交表单
        const submitForm = () => {
            formRef.value.validate(async (valid) => {
                if (valid) {
                    try {
                        await apiStoreEqConfigSave(form);
                        ElMessage.success("设备添加成功");
                        dialogVisible.value = false;
                        getDeviceList();
                    } catch (error) {
                        ElMessage.error("设备添加失败: " + error);
                    }
                }
            });
        };

        // 删除设备
        const handleDeleteDevice = (row) => {
            ElMessageBox.confirm("确定要解绑该设备吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                try {
                    await apiStoreEqConfigDelete([row.id]);
                    ElMessage.success("设备解绑成功");
                    getDeviceList();
                } catch (error) {
                    ElMessage.error("设备解绑失败: " + error);
                }
            }).catch(() => {
                ElMessage.info("已取消解绑");
            });
        };

        onMounted(() => {
            getDeviceList();
        });

        return {
            deviceList,
            dialogVisible,
            form,
            formRef,
            handleAddDevice,
            submitForm,
            handleDeleteDevice,
            getDeviceList
        };
    }
};
</script>

<style scoped>.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.box-card {
    margin: 20px;
}
</style>
